/** Scene mode an input binding is valid in. */
export enum InputContext {
    Placement = 'Placement',
    Navigation = 'Navigation',
    Transformation = 'Transformation',
    Configuration = 'Configuration',
    View = 'View'
}
